<template>
  <div class="playback-progressbar">
    <vue-slider
      class="playback-progressbar-box"
      ref="rgPlaybackSlider"
      v-model="value"
      :min="dateRange.startTime"
      :max="dateRange.endTime"
      :interval="1"
      :tooltip-formatter="formatter"
      :process-style="processStyle"
      @change="onChange"
      @drag-start="onDragStart"
    ></vue-slider>
  </div>
</template>

<script>
import moment from "moment-timezone";
import VueSlider from "vue-slider-component";

export default {
  name: "PlaybackProgressbar",
  components: { VueSlider },
  props: ["dateRange", "nowTime"],
  data() {
    return {
      value: 0,
      formatter: v => `${moment.unix(v).format("YYYY/MM/DD HH:mm:ss")}`,
      processStyle: {
        border: "2px solid #4D9EF2",
      },
    };
  },
  watch: {
    nowTime(v) {
      this.value = v;
    },
    value(v) {
      if (v >= this.dateRange.endTime) {
        this.$emit("reachEndTime", this.dateRange.endTime);
      }
    },
  },
  methods: {
    onChange() {
      this.$emit("onChange", this.$refs.rgPlaybackSlider.getValue());
    },
    onDragStart() {
      this.$emit("onDragStart");
    },
    toJST() {
      return moment.unix(this.nowTime).format("YYYY/MM/DD HH:mm:ss");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.playback-progressbar {
  // propsでvue-sliderのホバーした時のスタイルを指定できなかっためこちらに記載
  ::v-deep .vue-slider {
    .vue-slider-rail {
      background-color: #e0e0e0;
    }
    &:hover {
      .vue-slider-rail {
        background-color: $aisea-pure-white;
      }
    }
  }
}
</style>
